export const state = {
    host: '',
    origin: '',
    settings: {
        logo: '',
        main_image: '',
        main_color: '',
        text_color: '',
        button_text_color: '',
    },
    hitfm_settings: {
        logo: require('../static/imgs/logos/hitfm.svg'),
        logo_width: 'w-170',
        main_image: require('../static/imgs/design/hitfm-box.png'),
        text_color: 'text-dark-blue',
        main_color: 'text-hitfm',
        button_color: 'bg-hitfm text-white',
        file_upload_button: 'bg-hitfm',
    },
    dfm_settings: {
        logo: require('../static/imgs/logos/dfm.svg'),
        logo_width: 'w-130',
        main_image: require('../static/imgs/design/dfm-box.png'),
        text_color: 'text-black',
        main_color: 'text-dfm',
        button_color: 'bg-dfm text-white',
        file_upload_button: 'bg-dfm',
    },
    maximum_settings: {
        logo: require('../static/imgs/logos/maximum.svg'),
        logo_width: 'w-170',
        main_image: require('../static/imgs/design/maximum-box.png'),
        text_color: 'text-black',
        main_color: 'text-maximum',
        button_color: 'bg-maximum text-black font-bold',
        file_upload_button: 'bg-maximum custom-file-upload-black',
    },
    montecarlo_settings: {
        logo: require('../static/imgs/logos/montecarlo.svg'),
        logo_width: 'w-250',
        main_image: require('../static/imgs/design/montecarlo-box.png'),
        text_color: 'text-black',
        main_color: 'text-montecarlo',
        button_color: 'bg-montecarlo text-white',
        file_upload_button: 'bg-montecarlo',
    },
    rr_settings: {
        logo: require('../static/imgs/logos/rr.svg'),
        logo_width: 'w-170',
        main_image: require('../static/imgs/design/rr-box.png'),
        text_color: 'text-rr-blue',
        main_color: 'text-rusradio',
        button_color: 'bg-rusradio text-white',
        file_upload_button: 'bg-rusradio',
    },
    rutv_settings: {
        logo: require('../static/imgs/logos/rutv.svg'),
        logo_width: 'w-170',
        main_image: require('../static/imgs/design/dfm-box.png'),
        text_color: 'text-black',
        main_color: 'text-dfm',
        button_color: 'bg-dfm text-white',
        file_upload_button: 'bg-dfm',
    },
};